﻿

gro.modules = gro.modules || {};

gro.modules.tableBuilder = function () {
    var builder = {};

    /**
     * @description Create a table.
     * @param {string} id string representing id set on <table>
     * @param {string} tableClasses classes of the <table>
     * @param {jsonData} json json containing the data
     * @param {jsonData} columnDefinitions array of column definitions
     * classes: space-separated string of classnames
     * displayName: string
     * value: string or function returning string
     * tablesawPriority: priority for tablesaw, if not set "persist" will be used
     * headerClasses: space-separated string of classes applied to th
     * @param {boolean} toggleColumns enable/disable toggling of table columns with tablesaw
     * @returns {string} returns a string representation of the html table
     */
    builder.create = function (id, tableClasses, json, columnDefinitions, toggleColumns) {
        {
            var headerRow = '';
            var bodyRows = '';
            var tableSaw = '';
            tableClasses = tableClasses || "";
            id = id || 'unnamedTable';

            if (toggleColumns) {
                tableClasses += " tablesaw tablesaw-columntoggle";
                tableSaw = 'data-tablesaw-mode="columntoggle"';
            }

            columnDefinitions.forEach(function (colDef) {
                var tablesawPriority = colDef.tablesawPriority || 'persist';
                headerRow += '<th scope="col" data-tablesaw-priority="';
                headerRow += tablesawPriority;
                headerRow += '" class=" ';

                if (colDef.headerClasses)
                    headerRow += colDef.headerClasses;

                headerRow += '">';
                headerRow += colDef.displayName + '</th>';
            });

            json.forEach(function (row) {
                bodyRows += '<tr title="' + row.ToolTip + '">';

                columnDefinitions.forEach(function (colDef) {
                    if (id === "availableSlotTable") {
                        bodyRows += '<td class="tablesaw-priority-0 ';
                    }
                    else {
                        bodyRows += '<td class="tablesaw-priority-0 ';
                    }

                    if (typeof (colDef.classes) === "function")
                        bodyRows += colDef.classes(row);
                    else
                        bodyRows += colDef.classes || " ";
                    bodyRows += '">';

                    if (typeof (colDef.value) === "function")
                        bodyRows += colDef.value(row);
                    else
                        bodyRows += colDef.value;
                    bodyRows += '</td>';
                });

                bodyRows += '</tr>';
            });

            return '<table id="' +
                id +
                '" class="' +
                tableClasses +
                '" ' +
                tableSaw +
                '><thead><tr>' +
                headerRow +
                '</tr></thead><tbody>' +
                bodyRows +
                '</tbody></table>';
        }
    };

    return builder;
}();
